<ng-template let-modal #editCategory>
  <div class="w-100 d-flex flex-column justify-content-start align-items-center edit-category p-2">
    <p class="edit-category-title"><i class="fa fa-pen"></i> Edit category</p>
<!-- 
    <div class="w-100 d-flex my-1 align-items-center ">
      <label class="mr-2 px-2">Name:</label>
      <input [(ngModel)]="nameOfCurrentCategory"  type="text" class="form-control w-50" placeholder="input name of category" />
    </div> -->

    <div class="w-100 d-flex my-1 align-items-center ">
      <label class="mr-2 px-2">Type group 1 name:</label>
      <input [(ngModel)]="typeOneNaming" type="text" class="form-control w-50" placeholder="input group 1 name" />
    </div>

    <div class="w-100 d-flex my-1 align-items-center ">
      <label class="mr-2 px-2">Type group 2 name:</label>
      <input [(ngModel)]="typeTwoNaming" type="text" class="form-control w-50" placeholder="input group 2 name" />
    </div>
    

    <div class="my-2">
      <button class="btn my-button-3" (click)="saveCategoryInfo()"><i class="fa fa-save" ></i> Save</button>
    </div>

    <div class="w-100 border d-flex flex-column my-2 p-2">
      <p class="px-2 mb-2">Types </p>
      <div class="w-100 d-flex align-items-end mb-2 ">
        <div class="d-flex flex-column">
          <input type="text" class="w-100 form-control mr-3" placeholder="New type's name" [(ngModel)]="newType"/>
          <div class="mt-1">
            <p class="mr-2">Group:</p>
            <span class="mr-2"><input type="radio" [(ngModel)]="newTypeGroup"  [value]="1">1</span>
            <span class="mr-2"><input type="radio" [(ngModel)]="newTypeGroup"  [value]="2">2</span>
          </div>
  
        </div>
       
        <button class="btn btn-sm btn-outline-primary add-btn" (click)="addNewType()">Add Type</button>
      </div>
      <div class="mt-2 d-flex flex-wrap w-100 p-2">
        <button class="btn btn-sm btn-outline-primary mr-2 mt-2" *ngFor="let type of currentProductCategoryAvailableTypes">
          {{type.name}}(type:{{type.type}})
          <i class="fa fa-x ml-2" (click)="removeTypeFromAfterConfirmation($event, type)"></i>
        </button>

      </div>
     
     

    </div>



  </div>
</ng-template>
<ng-template #seeProductList let-modal>
  <p class="mb-4 p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i class="fa-solid fa-handshake"></i> Similar Products</p>

  <div class="prods p-4">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view (view)="goToProduct($event)"  [list]="list" [isCommunityProduct]="true"> </common-product-card-view>
    </ng-container>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i class="fas fa-heart-broken"></i> No products found for your search</p>
</ng-template>

<div class="types" [class.side]="!isOnMobile" [class.side-left]="!isOnMobile">
  <div class="types__one" *ngIf="typeOneExists || isUserAnAdmin">
    <p class="header">{{ typeGroupingCustomNamesMap[1] ?? "Categories" }}
     <button *ngIf="isOnCategoryPage && isUserAnAdmin" class="t-btn p-2 " style="color: var(--primary); font-size: medium;" (click)="showEditCategoryModal()">
       <i class="fa fa-ellipsis-v"></i>
     </button>

    </p>
    <div class="type-btns">
      <ng-container *ngFor="let type of currentProductCategoryAvailableTypes">
        <div *ngIf="type.type == 1 && (isUserAnAdmin || showAllTypes || productTypes.has(type.id))" class="d-flex mr-2">
          <input type="checkbox" *ngIf="isUserAnAdmin && editable" (change)="handleTypeAssignment($event, type)" 
          [checked]="productTypes.has(type.id)" />
          <!-- <label [for]="type.id" class="btn btn-sm btn-outline-primary" (click)="toggleType(type)">
            
          </label> -->
          <button class="btn btn-sm btn-outline-primary m-1 types-btn" (click)="toggleType(type); searchUsingTypes()" [class.bright]="selectedTypeId == type.id">
            {{ type.name }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="types__two" *ngIf="typeTwoExists">
    <p class="header">{{ typeGroupingCustomNamesMap[2] ?? "Services" }}</p>
    <div class="type-btns">
      <ng-container *ngFor="let type of currentProductCategoryAvailableTypes">
        <div *ngIf="type.type == 2 && (isUserAnAdmin || showAllTypes || productTypes.has(type.id))" class="d-flex mr-2">
          <input   type="checkbox" *ngIf="isUserAnAdmin && editable" (change)="handleTypeAssignment($event, type)" 
           [checked]="productTypes.has(type.id)" />
          <!-- <label [for]="'type-' + type.id" class="btn btn-sm btn-outline-primary" (click)="toggleType(type)">
            {{ type.name }}
          </label> -->
          <button class="btn btn-sm btn-outline-primary m-1 types-btn" (click)="toggleType(type)" [class.bright]="selectedTypeId == type.id">
            {{ type.name }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-center flex-column align-items-center">
    <!-- <button *ngIf="typeTwoExists || typeOneExists" class="btn m-1  mb-2 search-btn"
    (click)="searchUsingTypes()"><i class="fas fa-search"></i> Search</button> -->
    <!-- <button   class="btn m-1  mb-2 search-btn" *ngIf="productsToCompare?.length" (click)="openCompareProductsModal()"><i class="fa-solid fa-code-compare"></i>  Compare Products</button> -->
  </div>
</div>
<!-- <div></div> -->
